import React, { Component } from 'react';
import styled from 'styled-components'

const DropdownWrapper = styled.button`
  color: ${props=> props.textColor}
  
  &:hover {
    color: ${props => props.textColor}
  }
  
  &.active-link {
    color: ${props => props.secondaryTextColor}
    background: ${props=> props.secondary}
  }

  & > item {
    color: ${props=> props.textColor}
  }
`

export default function SimpleDropdown({ condition, message, campaign, children, boldIt}){
  const font = campaign.font ? `font-${campaign.font}` : ''
  const colors = campaign.template && campaign.template.appearence && campaign.template.appearence.colors

  if(!condition) return null
  return(
    <div className="gl-navbar__dropdown-wrapper">
      <DropdownWrapper
        textColor={colors && colors["text-tertiary"]}
        secondaryTextColor={campaign.textColor}
        primary={colors && colors["background-page"]}
        secondary={campaign.header_hover_bg_color}
        className={`gl-navbar__dropdown-wrapper__campaigns navbar-campaign-link ${font} `}
        >
        {message}
        <i className="fas fa-angle-down gl-navbar__dropdown-wrapper__campaign-icon"></i>
      </DropdownWrapper>
      <div className={`gl-navbar__dropdown-wrapper__campaigns-content width-available ${font}`} >
        {children}
      </div>
    </div>
  )
}
